export default {
    props: ['studyId'],

    data() {
        return {
            // 资源id
            id: '',
            // 文档链接
            documentLink: ''
        }
    },

    methods: {
        // 获取资源
        getResourse(id) {
            this.$post('resources/get', {
                id: id,
                token: this.$store.state.id
            }).then(res => {
                if (res.data.status == 'success') {
                    let origin = window.location.origin;
                    this.documentLink = origin + "/pdfjs/web/viewer.html?file=" + origin + "/work/" + res.data.result.data;
                    // this.documentLink = this.baseUrl + "pdfjs/web/viewer.html?file=" + this.baseUrl + "work/" + res.data.result.data;
                    console.log(this.documentLink);
                }
            });
        },

        // 返回指定的数是否在某个区间内
        inInterval(target, value) {
            if (target >= -Math.abs(value) && target <= Math.abs(value)) {
                return true;
            }
            return false;
        }
    },

    created() {
        // 资源id
        this.id = this.studyId;
        this.getResourse(this.id);
    },

    mounted() {
        document.getElementById('iframe').onload = () => {
            //获取pdf内容元素
            let page = window.frames[0].document.getElementById('viewerContainer');
            //iframe框架高度
            let iframeHeight = document.querySelector('#iframe').scrollHeight;
            //获取pdf工具栏的高度
            let tabHeight = window.frames[0].document.querySelector('#toolbarViewerRight').scrollHeight;
            //监听pdf滚动
            page.onscroll = () => {
                // 获取页面到顶部的高度
                let pageScorllTop = window.frames[0].document.querySelector('#viewerContainer').scrollTop;
                //获取pdf内容元素高度
                let pageHeight = page.scrollHeight;
                console.log('pageHeight ', pageHeight);
                console.log('iframeHeight ', iframeHeight);
                console.log('tabHeight ', tabHeight);
                console.log('pageScorllTop ', pageScorllTop);

                console.log('pageHeight - pageScorllTop + tabHeight ', pageHeight - pageScorllTop + tabHeight);
                console.log('iframeHeight ', iframeHeight);

                if (this.inInterval(Number.parseInt(pageHeight - pageScorllTop + tabHeight) - Number.parseInt(iframeHeight), 1)) {
                    console.log('完成pdf了，可以提交进度')
                    // 给父组件传值保存当前的电子书阅读学习进度
                    this.$emit('pdfAccomplish', 2)
                }
            }
        }
    }
}
